module.exports = __webpack_public_path__ + "static/media/image-6.2263c29d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FacebookBusiness/image-6.png
// module id = 434
// module chunks = 0